export default __webpack_public_path__ + "static/media/financial.97c54af7.svg";